export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

// 根据业务类型Id和value获取物流状态的显示名称
export function getLogStatusTextByValue(bizCodeList, businessTypeId, val){
  let codeList = bizCodeList[businessTypeId]
  for (let i=0;i<codeList.length;i++){
      let code = codeList[i]
      if (code.value === val ){
          return code.name
      }
  }
}

// 根据业务类型Id获取业务类型名称
export function getBizTextByValue (bizList, val) {
  for (let i=0; i<bizList.length; i++){
    let biz = bizList[i]
    if (biz.id === val || biz.value === val) {
      return biz.name
    }
  }
}


// 根据类型和值(code)获取显示名称
export function getTextByTypeAndValue (codeList, type, val) {
  let typeCodeList = codeList[type]
  if (!typeCodeList) return
  for (let i=0; i<typeCodeList.length; i++){
    let code = typeCodeList[i]
    if (code.value === val ){
      return code.name
    }
  }
}

//判断是否是微信浏览器的函数
export function isWeiXin(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      return true;
  }else{
      return false;
  }
}

export function showMsg(msg, opts,callback){
  if (isWeiXin()){
      $.toast(msg,"text",callback);  // todo:import jquery-weui，instead of jquery
  }else{
      if (typeof layer != "undefined" ){
          layer.msg(msg, opts, callback)
      }else{
          alert(msg);
      }
  }
}

export function showErrorMsg(data){
  showMsg(Config.getMsg(data.code|| "10000"));
}


export function noSpace (str) {
  return str.replace(/\s+/g, "");
}

// 格式化金额(保留两位小数)
export function formatCurrency(num) {
  if (!num && num != 0) {
      return;
  }
  let result = (num.toString()).indexOf(".");
  if (result != -1) {
      return num.toFixed(2);
  } else {
      return num + ".00"
  }
};
// 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
// 详情查看javascript的数值范围
export function checkIDCard(idcode){
  // 加权因子
  var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
  // 校验码
  var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

  var code = idcode + "";
  var last = idcode[17];//最后一位

  var seventeen = code.substring(0,17);

  // ISO 7064:1983.MOD 11-2
  // 判断最后一位校验码是否正确
  var arr = seventeen.split("");
  var len = arr.length;
  var num = 0;
  for(var i = 0; i < len; i++){
      num = num + arr[i] * weight_factor[i];
  }
  
  // 获取余数
  var resisue = num%11;
  var last_no = check_code[resisue];

  // 格式的正则
  // 正则思路
  /*
  第一位不可能是0
  第二位到第六位可以是0-9
  第七位到第十位是年份，所以七八位为19或者20
  十一位和十二位是月份，这两位是01-12之间的数值
  十三位和十四位是日期，是从01-31之间的数值
  十五，十六，十七都是数字0-9
  十八位可能是数字0-9，也可能是X
  */
  var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

  // 判断格式是否正确
  var format = idcard_patter.test(idcode);

  // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
  return last === last_no && format ? true : false;
}